import { render, staticRenderFns } from "./UpAudio.vue?vue&type=template&id=21228688&scoped=true&"
import script from "./UpAudio.vue?vue&type=script&lang=js&"
export * from "./UpAudio.vue?vue&type=script&lang=js&"
import style0 from "./UpAudio.vue?vue&type=style&index=0&id=21228688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21228688",
  null
  
)

export default component.exports